// src/locales/ta/categories.js
export const categories = {
  // Page titles and descriptions
  title: "தயாரிப்பு வகைகள்",
  description: "சிறந்த மேலாண்மைக்காக படிநிலை வகைகளுடன் உங்கள் தயாரிப்புகளை ஒழுங்கமைக்கவும்",
  
  // Navigation
  addCategory: "வகை சேர்க்கவும்",
  createNewCategory: "புதிய வகை உருவாக்கவும்",
  editCategory: "வகை திருத்தவும்",
  createFirstCategory: "முதல் வகை உருவாக்கவும்",
  allCategories: "அனைத்து வகைகள்",
  
  // Form Fields
  categoryName: "வகை பெயர்",
  categoryNamePlaceholder: "வகை பெயரை உள்ளிடவும் (எ.கா: எலக்ட்ரானிக்ஸ், உடைகள்)",
  parentCategory: "பெற்றோர் வகை",
  selectParentCategory: "பெற்றோர் வகையைத் தேர்ந்தெடுக்கவும் (விருப்பம்)",
  
  // Search and Navigation
  searchCategories: "வகைகளைத் தேடவும்...",
  createUnder: "கீழ் உருவாக்கவும்",
  
  // Table Headers and Info
  totalCategories: "{{count}} வகைகள்",
  
  // Validation Messages
  nameRequired: "வகை பெயர் தேவை",
  nameMinLength: "வகை பெயர் குறைந்தபட்சம் 2 எழுத்துக்களாக இருக்க வேண்டும்",
  
  // Actions
  createCategory: "வகை உருவாக்கவும்",
  updateCategory: "வகை புதுப்பிக்கவும்",
  
  // Success/Error Messages
  categoryCreatedSuccess: "'{{categoryName}}' வகை வெற்றிகரமாக உருவாக்கப்பட்டது!",
  categoryUpdatedSuccess: "'{{categoryName}}' வகை வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  categoryDeletedSuccess: "'{{categoryName}}' வகை வெற்றிகரமாக நீக்கப்பட்டது.",
  failedToCreate: "வகை உருவாக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  failedToUpdate: "வகை புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  failedToDelete: "வகை நீக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  failedToLoadCategory: "வகை விவரங்களை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
  
  // Loading states
  loadingCategories: "வகைகள் ஏற்றப்படுகின்றன...",
  loadingCategoriesDesc: "உங்கள் தயாரிப்பு வகைகளைப் பெறும் வரை காத்திருக்கவும்.",
  
  // Empty states
  noCategories: "இன்னும் வகைகள் இல்லை",
  noCategoriesDesc: "உங்கள் தயாரிப்புகளை ஒழுங்கமைக்க உங்கள் முதல் தயாரிப்பு வகையை உருவாக்கவும்.",
  noSearchResults: "வகைகள் கிடைக்கவில்லை",
  noSearchResultsDesc: "உங்கள் தேடல் சொற்களை சரிசெய்ய முயற்சிக்கவும் அல்லது அனைத்து வகைகளையும் பார்க்க வடிகட்டிகளை அழிக்கவும்.",
  
  // Confirmation dialogs
  confirmDelete: "'{{categoryName}}' வகையை நீக்குவது உறுதியா? இந்த செயலை மாற்ற முடியாது மற்றும் இந்த வகையைப் பயன்படுத்தும் தயாரிப்புகளை பாதிக்கலாம்."
};